import {
  FETCH_RELATED,
  FETCH_INLINE_RELATED,
  FETCH_SWIMLANE
} from './constants'

const initialState = {
  related: [],
  suggested: [],
  swimlane: [],
  isFetching: {
    related: false,
    suggested: false,
    swimlane: false
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_RELATED['REQUEST']: {
      return {
        ...state,
        isFetching: { ...state.isFetching, related: true },
        related: []
      }
    }
    case FETCH_RELATED['SUCCESS']: {
      return {
        ...state,
        isFetching: { ...state.isFetching, related: false },
        related: action.related
      }
    }
    case FETCH_INLINE_RELATED['REQUEST']: {
      return {
        ...state,
        isFetching: { ...state.isFetching, suggested: true },
        suggested: []
      }
    }
    case FETCH_INLINE_RELATED['SUCCESS']: {
      return {
        ...state,
        isFetching: { ...state.isFetching, suggested: false },
        suggested: action.inlineRelated
      }
    }
    case FETCH_SWIMLANE['REQUEST']: {
      return {
        ...state,
        isFetching: { ...state.isFetching, swimlane: true },
        swimlane: []
      }
    }
    case FETCH_SWIMLANE['SUCCESS']: {
      return {
        ...state,
        isFetching: { ...state.isFetching, swimlane: false },
        swimlane: action.swimlanecontent
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/RelatedSidebar/reducer.js